import * as marietta from '../../..';
import { CONTROL_ACTIONMODE } from '../../Constants';
import { SVGSprite } from '../../flash/display';
import { EventDispatcher } from '../../flash/events';

/**
 * Rotate items
 */
export default class ControlRotator {
  rotateFunc: Function;

  rotateStartFunc: Function;

  rotateEndFunc: Function;

  viewObj: Element;

  assistLine: Element;

  x: number;

  y: number;

  transformMatrix: string;

  private enterFrameObj: EventDispatcher;

  private moveMouseEvent: MouseEvent;

  /**
   * コンストラクタ
   */
  constructor(container: Element) {
    this.enterFrameObj = new EventDispatcher();
    this.viewObj = document.querySelector('#lib_control_rotater svg > g').cloneNode(true) as HTMLElement;
    this.viewObj.setAttribute('id', 'rotator');
    container.appendChild(this.viewObj);

    // アクション
    if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
      this.viewObj.addEventListener('touchstart', this.onMouseDownMe, { passive: false });
    } else {
      this.viewObj.addEventListener('mousedown', this.onMouseDownMe);
    }
  }

  /**
   * マウスダウンされた
   * @param MouseEvent
   */
  onMouseDownMe = (e: MouseEvent) => {
    // 初期配置モードではなく、選択モードのときはバブリングさせない
    if (!marietta.webcad.WebCADGlobal.itemManager.currentItem?.isFollowingMouse && marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM) {
      e.stopPropagation();
    }

    e.preventDefault();
    // 回転の開始
    if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
      document.addEventListener('touchmove', this.onMouseMoveMe, { passive: false });
      document.addEventListener('touchend', this.onMouseUpMe, { passive: false });
    } else {
      document.addEventListener('mousemove', this.onMouseMoveMe);
      document.addEventListener('mouseup', this.onMouseUpMe);
    }

    const scope: ControlRotator = this;
    // comment k.kubonaka
    // mousemoveハンドラのタイミングで描画処理を行うとIEで極端にFPS低下するため
    // 実際の描画処理は、SpriteのEnterFrame(setTimeOut)ベースで行う
    this.enterFrameObj.onEnterFrame = (): void => {
      if (scope.moveMouseEvent != null) {
        scope.rotateFunc(scope.moveMouseEvent);
      }
    };

    if (this.rotateStartFunc) {
      this.rotateStartFunc(e);
    }
  };

  /**
   * マウスが移動した
   */
  onMouseMoveMe = (e: MouseEvent) => {
    e.preventDefault();
    this.moveMouseEvent = e;
    // this.rotateFunc( e );
  };

  /**
   * マウスがUPされた
   */
  onMouseUpMe = (e: MouseEvent) => {
    e.preventDefault();
    this.enterFrameObj.deleteEnterFrame();
    this.moveMouseEvent = null;

    let ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      document.removeEventListener('touchmove', this.onMouseMoveMe);
      document.removeEventListener('touchend', this.onMouseUpMe);
    } else {
      document.removeEventListener('mousemove', this.onMouseMoveMe);
      document.removeEventListener('mouseup', this.onMouseUpMe);
    }
    ua = null;

    if (this.rotateEndFunc !== undefined) {
      this.rotateEndFunc();
    }

    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();

    this.showAssist(false);
  };

  /**
   * 移動 XY
   */
  move(x: number, y: number) {
    this.x = x;
    this.y = y;
    this.updateTranslate();
  }

  /**
   * 移動X
   */
  moveX(x: number) {
    this.x = x;
    this.updateTranslate();
  }

  /**
   * 移動Y
   */
  moveY(y: number) {
    this.y = y;
    this.updateTranslate();
  }

  /**
   * Translateのアップデート
   */
  updateTranslate() {
    // レイヤーのスケールの分、割ってやる事で見た目のサイズを維持する
    const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
    let sc: number = 1 / root.scaleX;

    // iPad・スマホは掴みやすくする
    if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
      sc *= 2; // 2倍の大きさにする
    }

    // x,yについては、位置補正で使用している固定値6.5/25に対してのみスケールを適用する
    this.transformMatrix = `matrix(${sc},0,0,${sc},${this.x + 6.5 - 6.5 * sc},${this.y + 25 - 25 * sc})`;

    // this.transformMatrix = "matrix(1,0,0,1," + this.x + "," + this.y + ")";
    this.viewObj.setAttribute('transform', this.transformMatrix);
  }

  /**
   * 回転のアシスト機能
   * */
  showAssist(booValue: boolean) {
    // 1回目の表示
    if (this.assistLine === undefined && booValue === true) {
      this.assistLine = document.querySelector('#lib_assistLine svg > g').cloneNode(true) as HTMLElement;
      this.assistLine.setAttribute('id', 'rotator_assistLine');
      this.assistLine.setAttribute('transform', 'matrix( 1,0,0,1,6.5,25)');
      this.viewObj.appendChild(this.assistLine);
      return;
    }

    if ((<HTMLElement>document.querySelector('#rotator_assistLine')) != null) {
      (<HTMLElement>document.querySelector('#rotator_assistLine')).style.visibility = booValue ? 'visible' : 'hidden';
    }
  }

  /**
   * アイコンの非表示
   */
  hide() {
    (<HTMLElement> this.viewObj).style.visibility = 'hidden';
  }

  /**
   * アイコンの表示
   */
  show() {
    (<HTMLElement> this.viewObj).style.visibility = 'visible';
  }
}
